
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Les 10 facteurs importants pour le classement sur Google",
    description:
      "Découvrez les plus grands facteurs qui influencent le classement sur Google. Optimisez votre site pour améliorer votre visibilité et attirer plus de visiteurs.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
